<style>
.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.innerRegister {
  margin-left: auto;
  margin-right: auto;
  width: 850px;
}
</style>
<template>
  <div id="password-rest-sent">
    <div v-if="!$vuetify.breakpoint.mobile" class="outer">
      <div class="middle">
        <div class="innerRegister">
          <v-row>
            <v-col>
              <v-card class="rounded-xl" elevation="7">
                <v-container>
                  <p class="text-center text-h4">Password Reset Sent</p>
                  <p class="text-center">
                    An email has been sent to the email you have provided,
                    follow the instructions in the email to reset your password.
                  </p>
                  <v-divider class="mt-12"></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="rounded-xl"
                      color="primary"
                      text
                      @click="$router.push('/login')"
                    >
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasswordResetSent"
}
</script>

<style scoped></style>
